export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyCDY1_05CiGv_9aS-xgyX_OQIUX_tSvySg",
    authDomain: "sctdgc.firebaseapp.com",
    databaseURL: "https://sctdgc.firebaseio.com",
    projectId: "sctdgc",
    storageBucket: "sctdgc.appspot.com",
    messagingSenderId: "1099280477148",
    appId: "1:1099280477148:web:c89affee3f8545f490bd19",
    // apiKey: "AIzaSyBC6Rg8BdYpol3OK7MOWrKAscNS9OowQqc",
    // authDomain: "supervisionweb-48b01.firebaseapp.com",
    // databaseURL: "https://supervisionweb-48b01.firebaseio.com",
    // projectId: "supervisionweb-48b01",
    // storageBucket: "supervisionweb-48b01.appspot.com",
    // messagingSenderId: "901386265834",
    // appId: "1:901386265834:web:dc6fbc2fdd238aee622393",
  },
  apiKeyGoogleCloud: "AIzaSyCDY1_05CiGv_9aS-xgyX_OQIUX_tSvySg",
};
